module.exports = __webpack_public_path__ + "static/media/teacher.19469aed.png";